// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_base-table-search_wrapper_3KWud","fields":"_base-table-search_fields_PXxgG"};